import React, {Component} from "react";
import PropTypes from "prop-types";
import footerStyles from "./footer.module.pcss";
import Markdown from "react-markdown";
import Row from "./../../components/row/row";
import CampudusLogo from "./../widgets/campudusLogo/campudusLogo";
import footerBg from "./../../../static/images/footer_bg.png";

const Footer = ({imprint, copyright, campudusClaim}) => {
  return (
    <Row displayFlex={false} rowWrapperClassName={footerStyles.footer}>
      <img src={footerBg} alt="Footer Background Image"/>
      <div className={footerStyles.campudusLogo}>
        <CampudusLogo />
        <Markdown source={campudusClaim} />
      </div>
      <div className={footerStyles.copyRight}>
        <p>{copyright}</p>
        <Markdown source={imprint} />
      </div>
    </Row>
  )
};

Footer.propTypes = {
  imprint: PropTypes.string.isRequired,
  campudusClaim: PropTypes.string.isRequired,
  copyright: PropTypes.string.isRequired
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.js